/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Project_Ids_Foreign_ProjectInputs */

const es_co2_error_project_ids_foreign_project = /** @type {(inputs: Error_Project_Ids_Foreign_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno de los proyectos seleccionados no pertenece a esta empresa.`)
};

/**

* @param {Error_Project_Ids_Foreign_ProjectInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_project_ids_foreign_project = /** @type {((inputs?: Error_Project_Ids_Foreign_ProjectInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Project_Ids_Foreign_ProjectInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_project_ids_foreign_project(inputs)
});